const LOCAL_STORAGE_JWT_TOKEN_NAME = "real-commerce-account-jwt";
export { LOCAL_STORAGE_JWT_TOKEN_NAME };
